export default "__VITE_ASSET__CwBlR5FP__"